import script from "./CreateItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CreateItem.vue?vue&type=script&setup=true&lang=ts"

import "./CreateItem.vue?vue&type=style&index=0&id=41f290da&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41f290da"]])

export default __exports__